import { MainLayoutWrapper } from "~/components/layout/MainLayoutWrapper";
import { UserRole } from "~/types/user";

interface MainLayoutProps {
  children: React.ReactNode;
  userRole: UserRole;
  pageTitle?: string;
}

export function MainLayout({ children, userRole }: MainLayoutProps) {
  return <MainLayoutWrapper userRole={userRole}>{children}</MainLayoutWrapper>;
}
